import { z } from 'zod';
import http from '@/lib/http';
import { CompanyBookingDto, CompanyBookingDtoSchema } from '@cargovibe/shared-types';

export const getOrganizationBookings = (): Promise<CompanyBookingDto[]> =>
  http.get<CompanyBookingDto[]>('/getOrganizationBookings', z.array(CompanyBookingDtoSchema));
